import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const login = (email, senha) => api.post('/auth/login', { email, senha });
export const cadastro = (dados) => api.post('/auth/cadastro', dados);
export const getMe = () => api.get('/auth/me');

export const getProdutos = () => api.get('/produtos');
export const getProdutosAdmin = () => api.get('/produtos/todos');
export const criarProduto = (dados) => api.post('/produtos', dados);
export const atualizarProduto = (id, dados) => api.put(`/produtos/${id}`, dados);
export const deletarProduto = (id) => api.delete(`/produtos/${id}`);

export const uploadLogo = (form) => api.post('/upload/logo', form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const uploadBanner = (form) => api.post('/upload/banner', form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const uploadFotoProduto = (id, form) => api.post(`/upload/produto/${id}`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
export const removerFotoProduto = (id) => api.delete(`/upload/produto/${id}/foto`);
export const moverProduto = (id, direcao) => api.post(`/produtos/${id}/mover`, { direcao });

export const getConfiguracoes = () => api.get('/configuracoes');
export const getConfiguracoesPublico = () => api.get('/configuracoes/publico');
export const salvarConfiguracoes = (dados) => api.put('/configuracoes', dados);
export const salvarCredenciais = (dados) => api.put('/configuracoes/credenciais', dados);

export const criarPedido = (dados) => api.post('/pedidos', dados);
export const confirmarPagamento = (id) => api.post(`/pedidos/${id}/confirmar-pagamento`);
export const meusPedidos = () => api.get('/pedidos/meus');
export const getPedido = (id) => api.get(`/pedidos/${id}`);
export const getPedidosAdmin = (params) => api.get('/pedidos', { params });
export const atualizarStatus = (id, status) => api.patch(`/pedidos/${id}/status`, { status });

export const getRecompensas = () => api.get('/fidelidade/recompensas/publico');
export const resgatar = (recompensa_id) => api.post('/fidelidade/resgatar', { recompensa_id });
export const getExtrato = () => api.get('/fidelidade/extrato');

export const getRoletaConfig = () => api.get('/roleta/config');
export const girarRoleta = (pedido_id) => api.post('/roleta/girar', { pedido_id });
export const salvarRoletaConfig = (dados) => api.put('/roleta/config', dados);
export const atualizarPremio = (id, dados) => api.put(`/roleta/premios/${id}`, dados);

export const getFaturamento = (periodo) => api.get('/relatorios/faturamento', { params: { periodo } });
export const getClientesRanking = () => api.get('/relatorios/clientes');
export const getProdutosMaisVendidos = () => api.get('/relatorios/produtos-mais-vendidos');
export const getAdicionais = () => api.get('/adicionais');
export const getAdicionaisAdmin = () => api.get('/adicionais/admin');
export const criarAdicional = (dados) => api.post('/adicionais', dados);
export const atualizarAdicional = (id, dados) => api.put(`/adicionais/${id}`, dados);
export const deletarAdicional = (id) => api.delete(`/adicionais/${id}`);

export default api;
